import { convertLocalCoreObjectToRemoteFormat, safeGetLocalStorage, safeSetLocalStorage } from "@/js/utilities";
import { defineStore } from "pinia";
import defaultPipelineList from "@/assets/_pipelineList.json";

export const usePipelinesStore = defineStore("pipelines", {
	state: () => ({ pipelineList: [] }),
	getters: {
		getPipelineByPipelineID: (state) => (pipelineID) => {
			return state.pipelineList.find((x) => x.pipelineID === pipelineID);
		},
	},
	actions: {
		setPipelineList(pipelineList) {
			this.pipelineList = pipelineList;
			safeSetLocalStorage("pipeline-list", this.pipelineList);
		},
		addToPipelineList(pipeline) {
			// assert non existence
			if (!this.pipelineList.find((x) => x.pipelineID === pipeline.pipelineID)) {
				this.pipelineList.push(pipeline);
				safeSetLocalStorage("pipeline-list", this.pipelineList);
			} else {
				console.warn("Already connected to " + pipeline.pipelineID);
			}
		},
		removeFromPipelineList(pipeline) {
			this.pipelineList.splice(
				this.pipelineList.findIndex((x) => x.pipelineID === pipeline.pipelineID),
				1,
			);
			safeSetLocalStorage("pipeline-list", this.pipelineList);
		},
		updatePipelineList(pipeline) {
			pipeline.updated_at = new Date().toISOString();
			this.pipelineList.splice(
				this.pipelineList.findIndex((x) => x.pipelineID === pipeline.pipelineID),
				1,
				pipeline,
			);
			safeSetLocalStorage("pipeline-list", this.pipelineList);
		},
		updatePipelineListSilent(pipeline) {
			this.pipelineList.splice(
				this.pipelineList.findIndex((x) => x.pipelineID === pipeline.pipelineID),
				1,
				pipeline,
			);
			safeSetLocalStorage("pipeline-list", this.pipelineList);
		},

		initialisePipelinesFromLocalStorage() {
			let pipelineList = safeGetLocalStorage("pipeline-list", defaultPipelineList);

			pipelineList = pipelineList.filter((r) => {
				return r?.pipelineID;
			});

			pipelineList.map((pipelineConfig) => {
				pipelineConfig.nodes = pipelineConfig.nodes.map((node) => {
					node.config.executionCore = convertLocalCoreObjectToRemoteFormat(node.config.executionCore);
					return node;
				});
				return pipelineConfig;
			});

			this.setPipelineList(pipelineList);
		},
	},
});
